import React, { FC } from 'react';
import { AuthenticationContainer } from '@components/organisms/AuthenticationContainer';
import { SetNewPasswordCard } from '@components/molecules/authentication/SetNewPasswordCard';

export const SetNewPassword: FC = () => {
    return (
        <AuthenticationContainer>
            <SetNewPasswordCard />
        </AuthenticationContainer>
    );
};
